<template>
  <div class="order">
    <div class="head">
      <AppFrame/>
    </div>
    <div class="cont">
      <div class="van-cont-block">
        <van-form ref="submitForm">
          <p class="van-cont__title">发货方</p>
          <van-field
            readonly
            clickable
            name="supply_point_name"
            :value="subForm.supply_point_name"
            label="处理网点"
            placeholder="请选择"
            @click="showPickerCustomerInfos = true"
            right-icon="arrow"
          ></van-field>
          <van-field
            readonly
            clickable
            name="business_type_name"
            :value="subForm.business_type_name"
            label="业务类型"
            placeholder="请选择"
            @click="showPickerBusinessTypeList = true"
            right-icon="arrow"
          ></van-field>
          <van-field
            readonly
            clickable
            name="consignerName"
            :value="subForm.consignerName"
            label="发货单位"
            placeholder="请选择"
            @click="getConsigneesGetList(1)"
            right-icon="arrow"
          ></van-field>
          <van-field
            readonly
            clickable
            name="beginDate"
            :value="subForm.beginDate"
            label="发货时间"
            placeholder="请选择"
            @click="showPickerBeginDate = true"
            is-link
          ></van-field>
          <van-field
            readonly
            clickable
            name="consignerAlias"
            :value="subForm.consignerAlias"
            label="发货地点"
            placeholder="请选择"
            @click="showPickerConsignerAddress = true"
            right-icon="arrow"
          ></van-field>
          <p class="van-cont__title">收货方</p>
          <van-field
            readonly
            clickable
            name="endDate"
            :value="subForm.endDate"
            label="希望送达时间"
            placeholder="请选择"
            @click="showPickerEndDate = true"
            right-icon="arrow"
          ></van-field>
          <van-field
            readonly
            clickable
            name="receiverName"
            :value="subForm.receiverName"
            label="收货单位"
            placeholder="请选择"
            @click="getConsigneesGetList(2)"
            right-icon="arrow"
          ></van-field>
          <van-field
            readonly
            clickable
            name="receiverAlias"
            :value="subForm.receiverAlias"
            label="收货地点"
            placeholder="请选择"
            @click="showPickerReceiverAddress = true"
            right-icon="arrow"
          ></van-field>
          <p class="van-cont__title">货品清单</p>
          <van-field
            readonly
            clickable
            name="supplyTransportGoodsFormList[0].prodName"
            :value="subForm.supplyTransportGoodsFormList[0].prodName"
            label="货品名称"
            placeholder="请选择"
            @click="openGetProducts()"
            right-icon="arrow"
          ></van-field>
          <van-field
            type="number"
            label="计划发货量"
            name="supplyTransportGoodsFormList[0].amount"
            v-model="subForm.supplyTransportGoodsFormList[0].amount"
            placeholder="请输入"
            @input="inputAmount"
            @click-right-icon="showPickerProductUnits = true"
          >
            <template #right-icon>
              <span class="c-333">单位：</span>
            </template>
            <template #extra>
              <span v-html="subForm.supplyTransportGoodsFormList[0].amountUnitStr"></span>
              <van-icon name="arrow" class="search-icon" />
            </template>
          </van-field>
          <van-field
            name="supplyTransportGoodsFormList[0].carCount"
            v-model="subForm.supplyTransportGoodsFormList[0].carCount"
            type="number"
            label="车数"
            placeholder="请输入车数"
          ></van-field>
          <van-field
            name="tranRequire"
            v-model="subForm.supplyTransportGoodsFormList[0].tranRequire"
            label="服务要求"
            placeholder="请输入服务要求"
            type="textarea"
          ></van-field>
          <div style="margin: 16px;">
            <van-button :disabled=subDisabled block type="info" @click="onSubmit">
              提交
            </van-button>
          </div>
          <div style="height: 240px"></div>
        </van-form>
      </div>
    </div>
    <!-- 选择弹窗 -->
    <!-- 选择处理点 -->
    <van-popup v-model="showPickerCustomerInfos" position="bottom" safe-area-inset-bottom>
      <van-picker
        show-toolbar
        :columns="queryCustomerInfos"
        value-key="name"
        @confirm="onConfirmCustomerInfos"
        @cancel="showPickerCustomerInfos = false"
      ></van-picker>
    </van-popup>
    <!-- 选择业务类型 -->
    <van-popup v-model="showPickerBusinessTypeList" position="bottom" safe-area-inset-bottom>
      <van-picker
        show-toolbar
        :columns="businessTypeList"
        value-key="name"
        @confirm="onConfirmBusinessTypeList"
        @cancel="showPickerBusinessTypeList = false"
      ></van-picker>
    </van-popup>
    <!-- 选择发货单位 -->
    <van-popup
      v-model="showPickerConsigner"
      position="right"
      :style="{ width: '100%',height: '100%' }"
    >
      <div class="search-box-arrow-left">
        <van-nav-bar
          left-arrow
          @click-left="onClickLeft"
        >
          <template #title>
            <van-search v-model="consignerSval" shape="round" clearable :placeholder="'搜索单位名称'" :left-icon="require('@/styles/img/icon_search.png')" background="transparent" @search="consignerSFun"/>
          </template>
        </van-nav-bar>
        <div class="search-list">
          <van-list>
            <van-cell v-for="(item,index) in consigneesGetList" :key="index" :title="item.name" @click="changeConsigneesGetList(item)">
                <template #icon>
                  <van-icon v-if="item.id==subForm.consignerId" name="checked" class="search-icon" color="#4687F5" />
                  <van-icon v-else name="hotel-o" class="search-icon"/>
                </template>
              </van-cell>
          </van-list>
        </div>
      </div>
    </van-popup>
    <!-- 选择收货单位 -->
    <van-popup
      v-model="showPickerReceiver"
      position="right"
      :style="{ width: '100%',height: '100%' }"
    >
      <div class="search-box-arrow-left">
        <van-nav-bar
          left-arrow
          @click-left="onClickLeft"
        >
          <template #title>
            <van-search v-model="consignerSval" shape="round" clearable :placeholder="'搜索单位名称'" :left-icon="require('@/styles/img/icon_search.png')" background="transparent" @search="consignerSFun"/>
          </template>
        </van-nav-bar>
        <div class="search-list">
          <van-list>
            <van-cell v-for="(item,index) in receiverGetList" :key="index" :title="item.name" @click="changReceiverList(item)">
                <template #icon>
                  <van-icon v-if="item.id==subForm.receiverId" name="checked" class="search-icon" color="#4687F5" />
                  <van-icon v-else name="hotel-o" class="search-icon"/>
                </template>
              </van-cell>
          </van-list>
        </div>
      </div>
    </van-popup>
    <!--选择发货时间-->
    <van-popup v-model="showPickerBeginDate" position="bottom" safe-area-inset-bottom>
      <van-datetime-picker
        type="datetime"
        v-model="beginDate"
        @confirm="onConfirmBeginDate"
        @cancel="showPickerBeginDate = false"
      ></van-datetime-picker>
    </van-popup>
    <!--选择收货时间-->
    <van-popup v-model="showPickerEndDate" position="bottom" safe-area-inset-bottom>
      <van-datetime-picker
        type="datetime"
        v-model="endDate"
        @confirm="onConfirmEndDate"
        @cancel="showPickerEndDate = false"
      ></van-datetime-picker>
    </van-popup>
    <!-- 选择发货地点 -->
    <van-popup v-model="showPickerConsignerAddress" position="bottom" safe-area-inset-bottom>
      <van-picker
        show-toolbar
        :columns="consignerAddressList"
        value-key="name"
        @confirm="onConfirmConsignerAddressList"
        @cancel="showPickerConsignerAddress = false"
      ></van-picker>
    </van-popup>
    <!-- 选择收货地点 -->
    <van-popup v-model="showPickerReceiverAddress" position="bottom" safe-area-inset-bottom>
      <van-picker
        show-toolbar
        :columns="receiverAddressList"
        value-key="name"
        @confirm="onConfirmReceiverAddressList"
        @cancel="showPickerReceiverAddress = false"
      ></van-picker>
    </van-popup>
    <!-- 选择货品名称 -->
    <van-popup
      v-model="showPickerProducts"
      position="right"
      :style="{ width: '100%',height: '100%' }"
    >
      <div class="search-box-arrow-left">
        <van-nav-bar
          left-arrow
          @click-left="onClickLeft"
        >
          <template #title>
            <van-search v-model="productsSval" shape="round" clearable :placeholder="'搜索货品名称'" :left-icon="require('@/styles/img/icon_search.png')" background="transparent" @search="getProducts(2)"/>
          </template>
        </van-nav-bar>
        <div class="search-list">
          <van-list v-if="nodata" v-model="loading" :finished="finished" finished-text="没有更多了" @load="getProducts()">
            <van-cell v-for="(item,index) in productsList" :key="index" :title="item.name" @click="changeGoods(item)">
              <template #icon>
                <van-icon v-if="item.id==subForm.supplyTransportGoodsFormList[0].prodId" name="checked" class="search-icon" color="#4687F5" />
                <van-icon v-else name="circle" class="search-icon"/>
              </template>
            </van-cell>
          </van-list>
          <van-empty v-else
            class="custom-image"
            :image="require('../../styles/img/nodata.png')"
          />
        </div>
      </div>
    </van-popup>
    <!-- 选择计量单位 -->
    <van-popup v-model="showPickerProductUnits" position="bottom" safe-area-inset-bottom>
      <van-picker
        show-toolbar
        :columns="productUnitsList"
        value-key="name"
        @confirm="onConfirmProductUnits"
        @cancel="showPickerProductUnits = false"
      ></van-picker>
    </van-popup>
  </div>
</template>

<script>
import AppFrame from '@/components/AppFrame'
import SearchBar from '../../components/SearchBar/index'
export default {
  name: "AddInvoice",
  components: {
    AppFrame,
    SearchBar
  },
  data() {
    return {
      subDisabled: false, // 提交按钮禁用
      nodata: true, // 商品-是否有数据
      loading: false, // 商品-是否上拉加载
      finished: false, // 商品-上拉加载是否结束即加载全部数据
      currentPage: 1, //商品-页数
      showCount: 20, //商品-每页个数
      consignerSval: '', //发货单位搜索
      productsSval: '', //货品名称搜索
      queryCustomerInfos: [] ,//处理网点
      showPickerCustomerInfos: false, //处理网点选择器显示隐藏
      businessTypeList: [
        { name: '干线普货运输', id: '1002996' },
        { name: '危货运输', id: 'D100000' },
        { name: '城市配送', id: '1003997' },
        { name: '农村配送', id: '1003998' },
        { name: '集装箱运输', id: '1002998' },
        { name: '其他', id: '1003999' }
      ],//业务类型列表，根据小程序写死
      showPickerBusinessTypeList: false, //业务类型选择器显示隐藏
      showPickerBeginDate: false,//发货时间选择器显示隐藏
      showPickerEndDate: false,//收货时间选择器显示隐藏
      beginDate:'',         //装货日期
      endDate:'',           //到货日期
      isConsigner: true,
      showPickerConsigner: false,//选择发货单位显示隐藏
      consigneesGetList:[], //发货单位地址列表
      showPickerConsignerAddress: false,//发货地点选择器显示隐藏
      consignerAddressList: [],//发货地点列表
      showPickerReceiver: false,//发货地点选择器显示隐藏
      receiverGetList:[], //收货单位地址列表
      showPickerReceiverAddress: false,//收货地点选择器显示隐藏
      receiverAddressList: [],//收货地点列表
      showPickerProducts: false,//货品名称选择器显示隐藏
      productsList: [],//货品名称列表
      showPickerProductUnits: false,//计量单位选择器显示隐藏
      productUnitsList: [],//计量单位列表
      subForm: {
        supply_point_id:'',   //处理网点id
        supply_point_name:'', //处理网点名称
        business_type:'',     //业务类型
        business_type_name:'',//业务类型名称
        consignerId:'',       //发货单位id
        consignerName:'',     //发货单位名称
        consignerAddressId:'',//发货地点id
        consignerAlias:'',    //发货地点简称
        beginDate:'',         //装货日期
        endDate:'',           //到货日期
        receiverId:'',        //收货单位id
        receiverName:'',      //收货单位名称
        receiverAddressId:'', //收货地点id
        receiverAlias:'',     //收货地点简称
        supplyTransportGoodsFormList:[
          {
            prodId:'',            //货品id
            prodName:'',          //货品名称
            amount:null,            //计划发货数
            amountUnitid:'',      //计划发货数单位Id
            amountUnitStr:'',     //计划发货数单位
            carCount:'',          //车数
            tranRequire:'',       //服务要求
          }
        ],  //货品信息
        tranRequire:'',       //服务要求
      },
    };
  },
  created() {
    this.subForm.beginDate = this.$options.filters.timeFormat(new Date().getTime())
    this.subForm.endDate = this.$options.filters.timeFormat(new Date().getTime()+60000)
    this.beginDate = new Date(this.subForm.beginDate)
    this.endDate = new Date(this.subForm.endDate)
  },
  mounted() {
    this.getQueryCustomerInfos()
    this.queryProductUnits()
    // 这种默认业务类型
    this.subForm.business_type = this.businessTypeList[0].id;
    this.subForm.business_type_name = this.businessTypeList[0].name;
  },
  methods: {
    //格式化计划发货量（有小数点且小数点后超过四位只取四位）
    inputAmount() {
      let amount = this.subForm.supplyTransportGoodsFormList[0].amount;
      if(amount.indexOf('.')>-1 && amount.split('.')[1].length>4){
        let value = Number(amount)
        this.subForm.supplyTransportGoodsFormList[0].amount = value.toFixed(4);
      }
    },
    // 获取处理网点
    getQueryCustomerInfos() {
      this.$api.apis.getQueryCustomerInfos({}).then(res => {
        // console.log('获取处理网点',res)
        if(!res.rsObj)return false
        this.queryCustomerInfos = res.rsObj.map(item=>{
            return {
              id:item.id,
              name:item.name
            }
        })
        if(!this.queryCustomerInfos) return false
        this.subForm.supply_point_id = this.queryCustomerInfos[0].id;
        this.subForm.supply_point_name = this.queryCustomerInfos[0].name;
      });
    },
    // 选择处理网点
    onConfirmCustomerInfos(value) {
      // console.log('选择处理网点',value)
      this.subForm.supply_point_id = value.id;
      this.subForm.supply_point_name = value.name;
      this.showPickerCustomerInfos = false;
    },
    // 选择业务类型
    onConfirmBusinessTypeList(value) {
      // console.log('选择业务类型',value)
      this.subForm.business_type = value.id;
      this.subForm.business_type_name = value.name;
      this.showPickerBusinessTypeList = false;
    },
    // 获取发货单位
    getConsigneesGetList(val,sval) {
      if(!sval)this.consignerSval = ''
      if(val=='1'){
        this.isConsigner = true
        this.showPickerConsigner = true
      }else if(val=='2'){
        this.isConsigner = false
        this.showPickerReceiver = true
      }
      // 单位类型 1：发货单位 2：收货单位
      let data = {
        type: val,
        name: sval?sval:''
      }
      this.$api.apis.getConsigneesGetList(data).then(res => {
        if(val=='1'){
          this.consigneesGetList = res.rsObj.list
        }else{
          this.receiverGetList = res.rsObj.list
        }
      });
    },
    // 搜索获取发货单位
    consignerSFun() {
      this.getConsigneesGetList(this.isConsigner?1:2,this.consignerSval)
    },
    // 选择收发货单位
    changeConsigneesGetList(item) {
      this.subForm.consignerId = item.id;
      this.subForm.consignerName = item.name;
      this.getQuerySenconsAddrByScId(item.id)
      this.showPickerConsigner = false;
    },
    // 选择收货单位
    changReceiverList(item) {
      this.subForm.receiverId = item.id;
      this.subForm.receiverName = item.name;
      this.getQuerySenconsAddrByScId(item.id)
      this.showPickerReceiver = false;
    },
    // 根据收发货单位Id获取收发货地点信息
    getQuerySenconsAddrByScId(id) {
      let data = {
        consigner_id:id
      }
      this.$api.apis.getQuerySenconsAddrByScId(data).then(res => {
        // console.log('获取收发货地点信息',res)
        let list = res.rsObj.list
        if(list&&list.length>0){
          if(this.isConsigner){
            this.consignerAddressList = list.map(item=>{
                return {
                  id:item.id,
                  name:item.alias
                }
            })
            this.subForm.consignerAddressId = list[0].id;
            this.subForm.consignerAlias = list[0].alias;
          }else{
            this.receiverAddressList = list.map(item=>{
                return {
                  id:item.id,
                  name:item.alias
                }
            })
            this.subForm.receiverAddressId = list[0].id;
            this.subForm.receiverAlias = list[0].alias;
          }
        }
      });
    },
    // 选择发货地点
    onConfirmConsignerAddressList(value) {
      this.subForm.consignerAddressId = value.id;
      this.subForm.consignerAlias = value.name;
      this.showPickerConsignerAddress = false;
    },
    // 选择收货地点
    onConfirmReceiverAddressList(value) {
      this.subForm.receiverAddressId = value.id;
      this.subForm.receiverAlias = value.name;
      this.showPickerReceiverAddress = false;
    },
    // 选择发货时间
    onConfirmBeginDate(value) {
      if(new Date(value).getTime() > new Date(this.subForm.endDate).getTime()){
        this.$toast("送达时间不能小于发货时间");
        return false
      }else{
        this.subForm.beginDate = this.$options.filters.timeFormat(new Date(value).getTime())
      }
      this.showPickerBeginDate = false;
    },
    // 选择收货时间
    onConfirmEndDate(value) {
      if(new Date(value).getTime() < new Date(this.subForm.beginDate).getTime()){
        this.$toast("送达时间不能小于发货时间");
        return false
      }else{
        this.subForm.endDate = this.$options.filters.timeFormat(new Date(value).getTime())
      }
      this.showPickerEndDate = false;
    },
    openGetProducts(){
      this.productsSval = '';
      this.currentPage = 1
      this.productsList = []
      this.finished = false
      this.loading = false
      this.showPickerProducts = true
      this.getProducts()
    },
    // 获取货品名称
    getProducts(type) {
      // 判断是否搜索
      if(type == 2){
        this.currentPage = 1
        this.productsList = []
        this.finished = false
        this.loading = false
      }
      if(!this.showPickerProducts)this.productsSval=''
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      let data = {
        currentPage: this.currentPage,
        showCount: this.showCount,
        pname: this.productsSval?this.productsSval:''
      }
      this.$api.apis.getProducts(data).then(res => {
        if(res&&res.rsObj&&res.rsObj.productVOList&&res.rsObj.productVOList.length>0){
          this.currentPage += 1;
          let list = res.rsObj.productVOList
          let lists = []
          lists = list.map(item=>{
            console.log(item)
              return {
                id: item.pid,
                name: item.pname
              }
          })
          this.productsList = this.productsList.concat(lists)
          // 加载状态结束
          this.loading = false
          if (list.length === 0||list.length<this.showCount ) {
            this.finished = true
          }
        }else{
          this.finished = true
          this.loading = false
          this.nodata = false
        }
        this.$toast.clear()
      });
    },
    // 选择货品名称
    changeGoods(item) {
      this.subForm.supplyTransportGoodsFormList[0].prodId = item.id;
      this.subForm.supplyTransportGoodsFormList[0].prodName = item.name;
      this.showPickerProducts = false;
    },
    // 获取计量单位
    queryProductUnits() {
      let data = {
        pname:''
      }
      this.$api.apis.queryProductUnits(data).then(res => {
        if(!res.rsObj||!res.rsObj.unitList)return false
        let unitList = res.rsObj.unitList
        this.productUnitsList = unitList.map(item=>{
            return {
              id: item.id,
              name: item.unitName
            }
        })
        if(this.productUnitsList&&this.productUnitsList.length>0){
          this.subForm.supplyTransportGoodsFormList[0].amountUnitid = this.productUnitsList[0].id;
          this.subForm.supplyTransportGoodsFormList[0].amountUnitStr = this.productUnitsList[0].name;
        }
      });
    },
    // 选择计量单位
    onConfirmProductUnits(item) {
      this.subForm.supplyTransportGoodsFormList[0].amountUnitid = item.id;
      this.subForm.supplyTransportGoodsFormList[0].amountUnitStr = item.name;
      this.showPickerProductUnits = false
    },
    // 点击弹窗的返回按钮时关闭弹窗
    onClickLeft() {
      this.showPickerBusinessTypeList = false;   //业务类型选择器显示隐藏
      this.showPickerBeginDate = false; //发货时间选择器显示隐藏
      this.showPickerEndDate = false; //收货时间选择器显示隐藏
      this.showPickerConsigner = false; //选择发货单位显示隐藏
      this.showPickerConsignerAddress = false;  //发货地点选择器显示隐藏
      this.showPickerReceiver = false;  //发货地点选择器显示隐藏
      this.showPickerReceiverAddress = false; //收货地点选择器显示隐藏
      this.showPickerProducts = false;  //收货地点选择器显示隐藏
      this.showPickerProductUnits = false;  //计量单位选择器显示隐藏
    },
    onSubmit(values) {
      // console.log('subForm', this.subForm);
      this.$toast.loading({
        message: '提交中...',
        forbidClick: true,
      });
      let data = {
        ...this.subForm
      }
      // console.log(data)
      if(data.supply_point_id == ''){
        this.$toast("处理网点");
        return false;
      }
      if(data.business_type == ''){
        this.$toast("业务类型");
        return false;
      }
      if(data.consignerId == ''){
        this.$toast("请选择发货单位");
        return false;
      }
      if(data.beginDate == ''){
        this.$toast("请选择发货时间");
        return false;
      }
      if(data.consignerAddressId == ''){
        this.$toast("请选择发货地点");
        return false;
      }
      if(data.endDate == ''){
        this.$toast("请选择送达时间");
        return false;
      }
      if(data.receiverId == ''){
        this.$toast("请选择收货单位");
        return false;
      }
      if(data.receiverAddressId == ''){
        this.$toast("请选择收货地点");
        return false;
      }
      if(data.supplyTransportGoodsFormList[0].prodId == ''){
        this.$toast("请选择货品名称");
        return false;
      }
      if(data.supplyTransportGoodsFormList[0].amount == ''){
        this.$toast("请输入计划发货数");
        return false;
      }
      if(data.supplyTransportGoodsFormList[0].carCount == ''){
        this.$toast("请输入车数");
        return false;
      }
      this.subDisabled = true
      this.$api.apis.addSupply(data).then(res => {
        // console.log(res)
        this.$toast.clear()
        if(res.flag=='200'){
          // this.$toast.success('提交成功');
          this.$dialog.alert({
            message: '发货单提交成功！',
            confirmButtonText:'确定'
          }).then(() => {
            this.$router.push({path:'/Invoice'})
          });
        }else{
          this.$toast(res.msg);
        }
        this.subDisabled = false
      }).catch(function(error) {
          this.subDisabled = false
          this.$toast('提交失败！');
      });
    },
  },
  destroyed() {
  },
  filters: {}
};
</script>
<style scoped lang="less">
  @import '../../styles/order.less';
</style>



// WEBPACK FOOTER //
// src/pages/Invoice/AddInvoice.vue